import type { MyLqaColumnView } from '@lqa-frontend/api-services';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

const columnViewsByKey = new Map<string, string[]>();

const MOCK_LATENCY_MS = 300;

export async function withLatency<T>(result: T): Promise<T> {
	await new Promise((resolve) => setTimeout(resolve, MOCK_LATENCY_MS));
	return result;
}

export async function getColumnView(
	viewKey: string
): Promise<MyLqaColumnView | null> {
	const columns = columnViewsByKey.get(viewKey);
	return withLatency(columns ? { viewKey, columns } : null);
}

export async function mockSaveColumnView(
	viewKey: string,
	columns: string[]
): Promise<MyLqaColumnView> {
	columnViewsByKey.set(viewKey, columns);
	return withLatency({ viewKey, columns });
}

export const MY_LQA_COLUMN_VIEW_QUERY_KEY = 'my-lqa-column-view-mock';

export function useMyLqaColumnViewQuery(viewKey: string) {
	return useQuery<MyLqaColumnView | null, AxiosError>({
		queryKey: [MY_LQA_COLUMN_VIEW_QUERY_KEY, viewKey],
		queryFn: () => getColumnView(viewKey),
	});
}
